import React, { createContext, useCallback } from 'react';
import { useWindowSize } from 'utils/hooks';

const SizeContext = createContext();

const SizeContextProvider = ({ children }) => {
  const { height } = useWindowSize();

  const getInnerHeight = useCallback(() => {
    return height - 1;
  }, [height]);

  return (
    <SizeContext.Provider value={{ getInnerHeight }}>
      {children}
    </SizeContext.Provider>
  );
};

export { SizeContextProvider, SizeContext };
